module.exports = __webpack_public_path__ + "static/media/audit-view-icon.a810f195.svg";